export const paginationComponentOptions = {
  rowsPerPageText: '１ページの表示数:',
  rangeSeparatorText: ' / ',
  noRowsPerPage: false,
  selectAllRowsItem: false,
  selectAllRowsItemText: 'All'
}
